import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import TopHeader from "../Dashoboard/TopHeader";
import AddIcon from "@mui/icons-material/Add";
import { editIcon, viewIcon } from "../../assets/img";
import ReactPaginate from "react-paginate";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { saveLoader } from "../../redux/slice/loaderNoti";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import moment from "moment/moment";
import {
  useLazyBookingListQuery,
  useLazyOwnerStatusQuery,
} from "../../redux/api/api";

const RoomBookingList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [list, setList] = useState([]);
  const [overAllCount, setOverALlCount] = useState(1);
  const [pagination, setPagonation] = useState({});
  const [search, setSearch] = useState("");
  const [status_value, setStatus_value] = useState("");
  const [row, setRow] = useState(10);
  const [filter, setFilter] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [btn, setBtn] = useState(false);

  // RTK QUERY
  const [listApi] = useLazyBookingListQuery();
  const [statusApi] = useLazyOwnerStatusQuery();

  const getList = (
    search_value,
    row_value,
    filter_value,
    from_date,
    to_date,
    status_
  ) => {
    let params = `?page=${page}`;

    if (search_value) {
      params += `&search=${search_value}`;
    }

    if (row_value) {
      params += `&row=${row_value}`;
    }

    if (filter_value) {
      params += `&filter=${filter_value}`;
    }

    if (status_) {
      params += `&status=${status_}`;
    }

    if (from_date) {
      params += `&from_date=${moment(from_date).format("YYYY-MM-DD")}`;
    }

    if (to_date) {
      params += `&to_date=${moment(to_date).format("YYYY-MM-DD")}`;
    }

    setSearch(search_value);
    setRow(row_value);
    setFilter(filter_value);
    setToDate(to_date);
    setFromDate(from_date);
    setStatus_value(status_);
    dispatch(saveLoader(true));
    listApi(params)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        setList(res?.bookings);
        setOverALlCount(
          Math.ceil(res?.pagination?.total / res?.pagination?.per_page)
        );
        setPagonation(res?.pagination);
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err", err);
      });
  };

  useEffect(() => {
    getList(search, row, filter, fromDate, toDate, status_value);
  }, [page]);

  const handlePageChange = (selectedObject) => {
    setPage(selectedObject.selected + 1);
  };

  const statusChange = (id) => {
    dispatch(saveLoader(true));
    setBtn(true);
    statusApi(id)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        setBtn(false);
        if (res?.status == "success") {
          Swal.fire({
            text: res?.message,
            icon: "success",
          });
          getList(search, row, filter, fromDate, toDate, status_value);
        }
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        setBtn(false);
        console.log("err");
      });
  };

  return (
    <div className="dashRightView home_section">
      <TopHeader type={"room-booking-list"} />
      <div className="block block-rounded ">
        <div className="block-content">
          <Row>
            <Col md={6}>
              <label className="table-labels f1">
                Total Count : {pagination?.total}
              </label>
            </Col>
          </Row>
          <div className="d-flex ac-jb gap-2">
            <div className="col-md-3 mb-2 p-0">
              <select
                className="form-control custom-select"
                onChange={(e) =>
                  getList(
                    search,
                    e.target.value,
                    filter,
                    fromDate,
                    toDate,
                    status_value
                  )
                }
                value={row}
              >
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
            </div>
            <div className="col-md-3 mb-2 p-0">
              <select
                className="form-control custom-select"
                onChange={(e) =>
                  getList(
                    search,
                    row,
                    e.target.value,
                    fromDate,
                    toDate,
                    status_value
                  )
                }
                value={filter}
              >
                <option value="">Filter</option>
                <option value="lh">Low to High</option>
                <option value="hl">High to Low</option>
              </select>
            </div>
            <div className="col-md-3 mb-2 p-0">
              <select
                className="form-control custom-select"
                onChange={(e) =>
                  getList(
                    search,
                    row,
                    e.target.value,
                    fromDate,
                    toDate,
                    status_value
                  )
                }
                value={status_value}
              >
                <option value="">Status</option>
                <option value="true">Check In</option>
                <option value="false">Check Out</option>
                <option value="canceled">Canceled</option>
              </select>
            </div>
          </div>
          <div className="d-flex ac-jb gap-2 mt-2">
            <div className="col-md-4 mb-2 p-0">
              <DatePicker
                selected={fromDate}
                onChange={(date) => {
                  getList(search, row, filter, date, toDate, status_value);
                }}
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                dateFormat="yyyy-MM-dd"
                todayButton="Today"
                className="form-control custom-select"
                placeholderText="YYYY-MM-DD"
              />
            </div>
            <div className="col-md-4 mb-2 p-0">
              <DatePicker
                selected={toDate}
                onChange={(date) =>
                  getList(search, row, filter, fromDate, date, status_value)
                }
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                dateFormat="yyyy-MM-dd"
                todayButton="Today"
                className="form-control custom-select"
                placeholderText="YYYY-MM-DD"
              />
            </div>
            <div className="col-md-3 mb-2 p-0">
              <input
                className="form-control bg-white px-3"
                placeholder="Eg: Property Id"
                onChange={(e) =>
                  getList(
                    e.target.value,
                    row,
                    filter,
                    fromDate,
                    toDate,
                    status_value
                  )
                }
                value={search}
              />
            </div>
          </div>
          <div className="table-custom-design overflow-scroll">
            <table>
              <thead>
                <tr className="text-capitalize text-nowrap">
                  <th>S.NO</th>
                  <th>Booking ID</th>
                  <th>From Date</th>
                  <th>To Date</th>
                  <th>Property Id</th>
                  <th>Service type</th>
                  <th>Actual Price(₹)</th>
                  <th>Paid Price(₹)</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {list?.map((item, ind) => {
                  return (
                    <tr key={ind}>
                      <td>{(pagination?.current_page - 1) * row + ind + 1}</td>
                      <td>
                        <button
                          className="link-btn"
                          onClick={() =>
                            navigate("/booked-rooms-view", {
                              state: { type: "view", data: item },
                            })
                          }
                        >
                          {item?.booking_id}
                        </button>
                      </td>
                      <td>
                        {item?.from_date
                          ? moment(item?.from_date).format("DD-MM-YYYY")
                          : "-"}
                      </td>
                      <td>
                        {" "}
                        {item?.to_date
                          ? moment(item?.to_date).format("DD-MM-YYYY")
                          : "-"}
                      </td>
                      <td>
                        {" "}
                        <button
                          className="link-btn"
                          onClick={() =>
                            navigate("/property-view", {
                              state: { type: "edit", data: item?.property },
                            })
                          }
                        >
                          {item?.property?.property_id}
                        </button>
                      </td>
                      <td>{item?.service_type ? item?.service_type : "-"}</td>
                      <td>
                        {" "}
                        {item?.total_payable_amount
                          ? item?.total_payable_amount
                          : "-"}
                      </td>
                      <td> {item?.amount_paid}</td>
                      <td
                        className={`${
                          item?.booking_status == 3
                            ? "text-danger"
                            : "text-success"
                        }`}
                      >
                        {" "}
                        {item?.check_out
                          ? "Check out"
                          : item?.check_out
                          ? "Check in"
                          : item?.booking_status == 3
                          ? "Canceled"
                          : "Booked"}
                      </td>
                      <td>
                        {" "}
                        <button
                          className="cust-btn"
                          onClick={() =>
                            navigate("/booked-rooms-view", {
                              state: { type: "view", data: item },
                            })
                          }
                        >
                          <img src={viewIcon} className="edit-btn" />
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="page-inner-cont py-2 d-flex justify-content-end">
            <ReactPaginate
              nextLabel="››"
              onPageChange={handlePageChange}
              pageRangeDisplayed={2}
              marginPagesDisplayed={2}
              pageCount={overAllCount}
              previousLabel="‹‹"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link"
              containerClassName="pagination"
              activeClassName="active"
              renderOnZeroPageCount={null}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default RoomBookingList;
